<template>
  <dropdown
    v-model="model"
    :items="methodOptions"
    item-text="label"
    item-value="value"
    :label="labelText"
    :rules="rules"
    :clearable="clearable"
  />
</template>

<script>
import hasModel from "@/mixins/hasModel";

// Fiksne vrednosti koje backend prihvata za način plaćanja/refundacije
// (bank/cash) - deljeno između Isplata, Plaćanja platformi i Refundacija,
// vidi network checklist T2 (16.09.2026).
export default {
  name: "PaymentMethodDropdown",

  mixins: [hasModel],

  props: {
    label: {
      type: String,
      default: "",
    },
    rules: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    labelText() {
      return this.label || this.$t("finance_payment_method_label");
    },
    methodOptions() {
      return [
        { label: this.$t("finance_method_bank"), value: "bank" },
        { label: this.$t("finance_method_cash"), value: "cash" },
      ];
    },
  },
};
</script>
